if(jQuery('body .customBanner').length){
    
    // setTimeout(function() {
    //     jQuery('.header-wrapper').css({"position": "absolute", "width": "100%"});
    // }, 500);

    let scroll = document.documentElement.scrollTop ||  window.pageYOffset;
    if(scroll > 400 ){
        jQuery('.header-wrapper').removeClass('bgTransparent');
    }else{
        jQuery('.header-wrapper').addClass('bgTransparent');
    }
    
   window.addEventListener("scroll", (event) => {
    let scroll = document.documentElement.scrollTop ||  window.pageYOffset;
    if(scroll > 400 ){
        jQuery('.header-wrapper').removeClass('bgTransparent');
    }
    else{
        jQuery('.header-wrapper').addClass('bgTransparent');
    }
  });
}
  else{
    jQuery('.header-wrapper').removeClass('bgTransparent');
    jQuery('.header-wrapper').css({"position": "relative", "width": "100%"});
  }


jQuery( document ).ready(function() {
      setTimeout(() => {
        AOS.init({
            offset: 20,
        });
    }, 120);
        document.addEventListener('scroll', function (event) {
        AOS.refresh();
        // console.log('1111');  
    });
    // Faq
	jQuery(".accordion__title").on("click", function(e) {
		e.preventDefault();
		var $this = jQuery(this);
		if (!$this.hasClass("accordion-active")) {
			jQuery(".accordion__content").slideUp(400);
			jQuery(".accordion__title").removeClass("accordion-active");
			jQuery('.accordion__arrow').removeClass('accordion__rotate');
		}
		$this.toggleClass("accordion-active");
		$this.next().slideToggle();
		jQuery('.accordion__arrow',this).toggleClass('accordion__rotate');
	});
    // Faq Two
    jQuery(".accordionTitle").on("click", function(e) {
		e.preventDefault();
		var $this = jQuery(this);
		if (!$this.hasClass("accordion-active")) {
			jQuery(".accordionContent").slideUp(400);
			jQuery(".accordionTitle").removeClass("accordion-active");
			jQuery('.accordionArrow').removeClass('accordion__rotate');
		}

		$this.toggleClass("accordion-active");
		$this.next().slideToggle();
		jQuery('.accordionArrow',this).toggleClass('accordion__rotate');
	});
  // See More btn
  jQuery("#seeMoreBtn").click(function(){

      var newText = 'Hide';
      if (jQuery(this).text() == newText) {
      newText = 'See More';
      }
          jQuery(".subtestimonial").slideToggle("800");
          
          jQuery(this).text(newText);
    })
       jQuery(".menu-drawer-container").click(function() {
          jQuery('.customHeader').toggleClass('menuBar');
        });
}); // document.ready limits end